import React from 'react'

const Slots = () => {
  return (
    <div>Slots</div>
  )
}

export default Slots